import { appConfig } from '../config';
import { apiRequest } from './client';

export type CameraStreamChoice = 'auto' | 'main' | 'sub';

export const getCameraStreamUrl = (
  cameraId: string,
  stream: CameraStreamChoice,
  cacheKey?: number,
) => {
  const query = new URLSearchParams({ stream });
  if (cacheKey !== undefined) query.set('v', String(cacheKey));
  return `${appConfig.cameraMediaUrl}/api/devices/${encodeURIComponent(cameraId)}/camera/stream.mjpeg?${query}`;
};

const playbackPath = (cameraId: string) => `/api/devices/${encodeURIComponent(cameraId)}/camera`;

export interface CameraPlaybackOptions {
  webRtc: boolean;
  hls: boolean;
  mjpeg: boolean;
  leaseSeconds: number;
  preferMjpeg?: boolean;
}

export interface CameraIceServer {
  urls: string[];
  username?: string;
  credential?: string;
}

export interface CameraWebRtcLease {
  id: string;
  answer: string;
  leaseSeconds: number;
}

export const getCameraPlaybackOptions = (cameraId: string, signal?: AbortSignal,
  stream: CameraStreamChoice = 'auto') =>
  apiRequest<CameraPlaybackOptions>(`${playbackPath(cameraId)}/playback?stream=${stream}`, { signal });

export const getCameraIceServers = (cameraId: string, stream: CameraStreamChoice, signal?: AbortSignal) =>
  apiRequest<CameraIceServer[]>(`${playbackPath(cameraId)}/webrtc/ice?stream=${stream}`, { signal });

export const createCameraWebRtcLease = (cameraId: string, stream: CameraStreamChoice,
  offer: string, signal?: AbortSignal) =>
  apiRequest<CameraWebRtcLease>(`${playbackPath(cameraId)}/webrtc`, {
    method: 'POST', body: { offer, stream }, signal,
  });

export const renewCameraWebRtcLease = (cameraId: string, leaseId: string) =>
  apiRequest<void>(`${playbackPath(cameraId)}/webrtc/${encodeURIComponent(leaseId)}/renew`, {
    method: 'POST',
  });

export const deleteCameraWebRtcLease = (cameraId: string, leaseId: string) =>
  apiRequest<void>(`${playbackPath(cameraId)}/webrtc/${encodeURIComponent(leaseId)}`, {
    method: 'DELETE', keepalive: true,
  });

export const getCameraHlsUrl = (cameraId: string, stream: CameraStreamChoice) =>
  `${appConfig.apiUrl}${playbackPath(cameraId)}/hls/index.m3u8?stream=${stream}`;
